














import type { ChatComment as IChatComment } from '@getaccept/lib-shared/src/chat/types/chat-comment';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { PropType } from '@vue/composition-api';
import { watch, onBeforeUnmount, onMounted, ref, defineComponent } from '@vue/composition-api';
import ChatComment from './ChatComment.vue';

export default defineComponent({
  components: { ChatComment },
  props: {
    recipientId: {
      type: String,
      required: true,
    },
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    comments: {
      type: Array as PropType<IChatComment[]>,
      required: true,
    },
    recipients: {
      type: Array as PropType<SigningPageRecipient[]>,
      required: true,
    },
  },
  setup(props) {
    const chatContentRef = ref<Element>(null);

    const commentAdded = () => {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    };
    watch(() => props.comments, commentAdded);

    const scrollToBottom = () => {
      const container = chatContentRef.value;
      if (!container) {
        return;
      }
      container.scrollTop = container.scrollHeight;
    };

    const resizeHandler = () => {
      if (window.innerWidth <= 600) {
        scrollToBottom();
      }
    };

    onMounted(() => {
      scrollToBottom();
      window.addEventListener('resize', resizeHandler);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', resizeHandler);
    });

    return {
      chatContentRef,
      commentAdded,
      scrollToBottom,
      resizeHandler,
    };
  },
});
